import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

/** FaqAccordion — reusable FAQ section renderer + JSON-LD schema helper. */
export function FaqAccordion({ items = [], testIdPrefix = "faq" }) {
  if (!items?.length) return null;
  return (
    <Accordion type="single" collapsible className="divide-y divide-tan">
      {items.map((f, i) => (
        <AccordionItem key={i} value={`item-${i}`} className="border-none">
          <AccordionTrigger
            className="text-left font-display text-xl md:text-2xl text-forest-900 py-6 hover:no-underline"
            data-testid={`${testIdPrefix}-trigger-${i}`}
          >
            {f.q}
          </AccordionTrigger>
          <AccordionContent
            className="text-ink/80 text-base leading-relaxed pb-6"
            data-testid={`${testIdPrefix}-answer-${i}`}
          >
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}

export function buildFaqLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: (items || []).map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}
